import { SharedModule } from '../../../shared/shared.module';
import { CagnottesViewComponent } from './cagnottes-view.component';
import { CagnottesDetailsResolver } from '../cagnottes-details/cagnottes-details.resolver';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';

@NgModule({
    imports: [
        NgbModule,
        SharedModule,
        BsDatepickerModule,
        DataTableModule
    ],
    declarations: [CagnottesViewComponent],
    exports: [CagnottesViewComponent],
    providers: [CagnottesDetailsResolver]
})
export class CagnottesViewModule { }
